import React from 'react';
import { Route } from 'react-router-dom';
import ContactSection from '../pages/contacts/ContactSection';
import ProtectedRoute from '../components/global/ProtectedRoute';

const contactsRoutes = (
    <Route
        path="/contacts/section"
        element={
            <ProtectedRoute requiredPermission="settings.contact-us.view">
                <ContactSection />
            </ProtectedRoute>
        }
    />
);

export default contactsRoutes;
